// extracted by mini-css-extract-plugin
export default {"fallback":"_5DZvawUD","spinner":"_5DRq1rr9"};